import { CtaBanner } from "~/components/common/cta/banner";
import { CommunityCta } from "~/components/common/cta/community";

interface MarketingLayoutProps {
  title: string;
  description: string;
  children: React.ReactNode;
  badge?: React.ReactNode;
  after?: React.ReactNode;
}

export const MarketingLayout = ({
  title,
  description,
  children,
  badge,
  after,
}: MarketingLayoutProps) => (
  <div className="!col-span-full grid grow grid-cols-subgrid gap-6 sm:gap-8 [&>*]:col-[2]">
    <section className="flex flex-col gap-6 sm:gap-8 md:gap-10 lg:gap-12 [&>*]:scroll-mt-4">
      <header className="mb-3 flex flex-col items-center justify-center gap-2 md:gap-3 lg:mb-0 lg:gap-4">
        {badge}
        <h1 className="max-w-5xl text-center text-4xl font-medium tracking-tight text-balance sm:text-5xl md:text-6xl">
          {title}
        </h1>

        <p className="text-muted-foreground max-w-3xl text-center text-sm text-balance md:text-base">
          {description}
        </p>
      </header>

      {children}
    </section>

    {after}

    <CommunityCta />
    <CtaBanner />
  </div>
);
